import React from 'react'

import { useQuery } from '@apollo/client'
import { cloneDeep } from 'lodash/lang'

import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      emergencyContactId, // via withParams
      setEmergencyContactForm, // via redux actiona
      setErrorMessage, // via redux actions
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const {
      loading: queryLoading,
      error: queryError,
      data: queryData
    } = useQuery(query, {
      variables: { emergencyContactId },
      onError: onQueryError,
      onCompleted: data => handleQueryCompleted(data)
    })
    // TODO: use callback to update form data

    const handleQueryCompleted = data => {
      if (!onLoggedInQueryCompleted(data)) {
        return
      }

      if (data && data.viewer) {
        const emergencyContact = data.viewer.emergencyContacts[0]

        if (!emergencyContact) {
          setErrorMessage('The emergency contact was not found')
          return
        }

        setEmergencyContactForm(cloneDeep(emergencyContact))
      }
    }

    // GraphQL data
    const { viewer: account, seasons } = queryData || {}
    const emergencyContact = account ? account.emergencyContacts[0] : null
    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        queryLoading={queryLoading}
        queryError={queryError}
        emergencyContact={emergencyContact}
        season={season}
        account={account}
        {...props}
      />
    )
  }
}

export default withQuery
